import { SellerInfo } from '../components/SellerInfo';
import { useSellerInfoService } from '../services/useSellerInfoService';

export const SellerInfoContainer: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { shop, is_hide } = useSellerInfoService();

  if (is_hide) {
    return null;
  }

  return <SellerInfo shop={shop} />;
};
